module.exports = __webpack_public_path__ + "img/v4_coCompetition_h.0ad0aa31.png";